var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEpgLoadingDesktopTop = function SvgEpgLoadingDesktopTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 177,
    height: 92,
    fill: "none",
    viewBox: "0 0 177 92"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70.567,
    height: 20,
    fill: "#1A1A1A",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 24,
    y: 36,
    fill: "#1A1A1A",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 24,
    y: 68,
    fill: "#1A1A1A",
    rx: 2
  })));
};
export default SvgEpgLoadingDesktopTop;